import Footer from "components/footer/footer";
import Modell from "components/modell/modell";
import Scroll from "shell/scroll/scroll";
import "./galaxy.scss";
import Page from "shell/page/page";
import { AppTypes } from "shell/app/app";
import { useStore } from "shell/store/store";

interface galaxyProps extends AppTypes {}

const Galaxy: React.FC<galaxyProps> = (props) => {
  const language = useStore((state) => state.language);
  const data = require(`data/galaxy.data.${language}.json`);

  return (
    <div className="galaxy">
      <Page {...props}>
      <Scroll>
        <Modell {...data.modell} />
        <Footer />
      </Scroll>
      </Page>
    </div>
  );
};

export default Galaxy;
